import React from 'react';
import { InfoPopover } from '@folio/stripes/components';
import { t } from '../../../services';
export var VisibilityTooltip = function (_a) {
    var isECS = _a.isECS;
    return (React.createElement(InfoPopover, { iconSize: "medium", content: React.createElement("div", null,
            t('create-list.main.list-visibility.tooltip'),
            isECS ? (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                React.createElement("br", null),
                t('create-list.cross-tenant-tip'))) : ('')) }));
};
